const INNER_SEARCH_GUTTER = '0.5rem';
const LIST_ITEMS_HEIGHT = '250px';

export { INNER_SEARCH_GUTTER, LIST_ITEMS_HEIGHT };
